<template>
    <div class="view cost-hours-split" v-if="loaded">
        <app-sub-navbar parent="cost"></app-sub-navbar>
        <div class="container-fluid">
            <app-filter @filterLoaded="redrawComponents"  class="text-center" @filterChanged="redrawComponents()" parent="cost"></app-filter>
            <app-total-table></app-total-table>
            <app-table></app-table>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import Filter from '../../components/cost/HoursSplitFilter'
import Table from '../../components/cost/HoursSplitTable'
import TotalTable from '../../components/cost/HoursSplitTotalTable'

export default {
    data () {
        return {
            loaded: false,
            loadTable: false,
            loading: false
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appFilter: Filter,
        appTable: Table,
        appTotalTable: TotalTable
    },
    methods: {
        redrawComponents () {
            this.loading = true
        }
    },
    created () {
        if (this.$store.getters['general/storesLoaded'] === false) {
            this.$store.dispatch('general/getStores').then(response => {
                this.loaded = true
                this.redrawComponents()
            })
        } else {
            this.loaded = true
            this.redrawComponents()
        }
    }
}
</script>
<style>
</style>
